<template>
  <div>
    <div class="fxSetData">
      <div class="fxSetContent">
        <div class="fxSetData-detail">
          <span class="fxSetDetail-title">控制方式</span>
          <span class="fxSetDetail-input">
            <el-select @change="selectVersion($event)" v-model="version" placeholder="请选择" :popper-append-to-body="false">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </span>
          <span class="fxSetDetail-tag"></span>
        </div>
        <div class="fxSetData-detail">
          <span class="fxSetDetail-title">开启时长</span>
          <span class="fxSetDetail-input">
            <el-input type="number" placeholder=0 v-model="openTime" @change="openTimeInput" clearable></el-input>
          </span>
          <span class="fxSetDetail-tag">(1~500)</span>
        </div>
        <div class="fxSetData-detail">
          <span class="fxSetDetail-title">上传周期</span>
          <span class="fxSetDetail-input">
            <el-input type="number" placeholder=0 v-model="sleepTime" @change="sleepTimeInput"  clearable ></el-input>
          </span>
          <span class="fxSetDetail-tag">(1~180)</span>
        </div>
        <div class="fxSetData-detail">
          <span class="fxSetDetail-title">定时开启(时)</span>
          <span class="fxSetDetail-input">
            <el-input type="number" placeholder=0 v-model="hourOpenTime" @change="hourOpenTimeInput"  clearable ></el-input>
          </span>
          <span class="fxSetDetail-tag">(0~23)</span>
        </div>
        <div class="fxSetData-detail">
          <span class="fxSetDetail-title">定时开启(分)</span>
          <span class="fxSetDetail-input">
            <el-input type="number" placeholder=0 v-model="minOpenTime" @change="minOpenTimeInput"  clearable ></el-input>
          </span>
          <span class="fxSetDetail-tag">(0~59)</span>
        </div>
        <div class="fxSetData-detail">
          <span class="fxSetDetail-title">光控开启电压</span>
          <span class="fxSetDetail-input">
            <el-input type="number" placeholder=0 v-model="openVoltage" @change="openVoltageInput" clearable ></el-input>
          </span>
          <span class="fxSetDetail-tag">(0~33)</span>
        </div>
        <div class="fxSetData-detail">
          <span class="fxSetDetail-title">光控延时时间</span>
          <span class="fxSetDetail-input">
            <el-input type="number" placeholder=0 v-model="openDelaytime" @change="openDelayTimeInput"  clearable ></el-input>
          </span>
          <span class="fxSetDetail-tag">(1~180)</span>
        </div>
        <div class="fxSetData-button">
          <span @click="commit" class="fxSetButton-style">提&nbsp;&nbsp;交</span>
          <span @click="btnOpen" class="fxSetButton-style">开&nbsp;&nbsp;启</span>
          <span @click="btnClose" class="fxSetButton-style">关&nbsp;&nbsp;闭</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {clientInfo, getAttributesClient, getCredentials} from "../untils/api/home";

  export default {
    name: 'fxSetData',
    components: {},
    data() {
      return {
        options: [{
          value: 2,
          label: '光控'
        }, {
          value: 3,
          label: '时控'
        }],
        version: 2,
        openTime: 240,
        sleepTime: 1,
        hourOpenTime: 18,
        minOpenTime: 0,
        openVoltage: 14,
        openDelaytime: 30,
        fxSetCredentialsId: '',
        fxJson: {},
        switchFlg: 3,
        time: 0,
      }
    },
    beforeDestroy() {
    },

    mounted() {

    },

    methods: {
      openTimeInput(value) {
        let min = 1;
        let max = 500;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "开启时长范围在1~500之间"
          });
        }
        if(value < min) {
          this.openTime = min;
        } else if(value > max) {
          this.openTime = max;
        }

        this.openTime = Math.floor(this.openTime);
      },

      sleepTimeInput(value) {
        let min = 1;
        let max = 180;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "上传周期范围在1~180之间"
          });
        }
        if(value < min) {
          this.sleepTime = min;
        } else if(value > max) {
          this.sleepTime = max;
        }

        this.sleepTime = Math.floor(this.sleepTime);
      },

      hourOpenTimeInput(value) {
        let min = 0;
        let max = 23;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "定时开启(时)范围在0~23之间"
          });
        }
        if(value < min) {
          this.hourOpenTime = min;
        } else if(value > max) {
          this.hourOpenTime = max;
        }

        this.hourOpenTime = Math.floor(this.hourOpenTime);
      },

      minOpenTimeInput(value) {
        let min = 0;
        let max = 59;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "定时开启(分)范围在0~59之间"
          });
        }
        if(value < min) {
          this.minOpenTime = min;
        } else if(value > max) {
          this.minOpenTime = max;
        }

        this.minOpenTime = Math.floor(this.minOpenTime);
      },

      openVoltageInput(value) {
        let min = 0;
        let max = 33;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "光控开启电压范围在0~33之间"
          });
        }
        if(value < min) {
          this.openVoltage = min;
        } else if(value > max) {
          this.openVoltage = max;
        }

        this.openVoltage = Math.floor(this.openVoltage);
      },

      openDelayTimeInput(value) {
        let min = 1;
        let max = 180;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "光控延时时间范围在1~180之间"
          });
        }
        if(value < min) {
          this.openDelaytime = min;
        } else if(value > max) {
          this.openDelaytime = max;
        }

        this.openDelaytime = Math.floor(this.openDelaytime);
      },

      selectVersion(event) {
        this.version = event;
      },

      commit() {
        this.setFxJson();
        this.fxSetClintInfo();
      },

      btnOpen() {
        this.switchFlg = 1;
        this.time =  Math.floor(Date.now() / 1000);
        this.setFxJson();
        this.fxSetClintInfo();
      },

      btnClose() {
        this.switchFlg = 0;
        this.time =  Math.floor(Date.now() / 1000);
        this.setFxJson();
        this.fxSetClintInfo();
      },

      setFxJson() {
        this.fxJson.op_fl = this.switchFlg;
        this.fxJson.op_t = parseInt(this.openTime);
        this.fxJson.h_op_t = parseInt(this.hourOpenTime);
        this.fxJson.m_op_t = parseInt(this.minOpenTime);
        this.fxJson.sT = parseInt(this.sleepTime);
        this.fxJson.opVol = parseInt(this.openVoltage);
        this.fxJson.opDt = parseInt(this.openDelaytime);
        this.fxJson.ver = this.version;
        if(this.time != 0) {
          this.fxJson.time = this.time;
        }
      },

      fxCredentialsInfo(deviceId) {
        getCredentials(deviceId).then(response => {
          this.fxSetCredentialsId = response.credentialsId;
          this.fxGetClientInfo();
        }).catch(error => {
          console.log("error", error)
        })
      },

      fxGetClientInfo() {
        getAttributesClient(this.fxSetCredentialsId).then(response => {
          this.switchFlg = 3;
          this.openTime = 240;
          this.hourOpenTime = 180;
          this.minOpenTime = 0;
          this.sleepTime = 1;
          this.openVoltage = 14;
          this.openDelaytime = 30;
          this.version = 2;
          this.time = 0;
          if(response.client != undefined) {
            for (let obj in response.client) {
              if(obj === 'cmd') {
                let json = JSON.parse(response.client[obj]);
                this.switchFlg = json.op_fl;
                this.openTime = json.op_t;
                this.hourOpenTime = json.h_op_t;
                this.minOpenTime = json.m_op_t;
                this.sleepTime = json.sT;
                this.openVoltage = json.opVol;
                this.openDelaytime = json.opDt;
                json.time === undefined ? this.time = 0 : this.time = json.time;
                this.version = json.ver;
              }
            }
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      fxSetClintInfo() {
        let cmdJson = {};
        cmdJson.cmd = JSON.stringify(this.fxJson);
        clientInfo(this.fxSetCredentialsId, cmdJson).then(response => {
          this.$message({
            showClose: true,
            type: "warning",
            message: "设置成功"
          })
        }).catch(error => {
          this.$message({
            showClose: true,
            type: "warning",
            message: "设置失败"
          })
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  @media screen and (max-width: 500px) {
    .fxSetData {
      width: 100%;
      overflow: auto;
      top: 1%;
      position: absolute;
      bottom: 1%;
    }

    .fxSetContent {
      width: 90%;
    }

    .fxSetData-detail {
      height: 15vw;
      width: 100%;
      margin-bottom: 2%;
      border: 1px outset #314963;
      background-color: #314963;
      display: flex;
      justify-content: space-between;
      border-radius: 50px;
      margin-left: 5%;

      .fxSetDetail-title {
        width: 30%;
        font-size: 4vw;
        color: #ffffff;
        margin: auto;
        text-align: center;
      }

      .fxSetDetail-input {
        width: 45%;
        display: flex;
        align-items: center;
        text-align: center;
      }

      .fxSetDetail-tag {
        width: 25%;
        font-size: 4vw;
        margin: auto;
      }

      /deep/.el-input__inner {
        height: 8vw;
        width: 80%;
        font-size: 4vw;
        border-radius: 20px;
      }
    }

    .fxSetData-button {
      height: 15vw;
      width: 100%;
      margin-bottom: 2%;
      display: flex;
      justify-content: space-between;
      margin-left: 5%;

      .fxSetButton-style {
        background-color: #345A7C;
        border: 1px outset #345A7C;
        height:65%; width: 30%;
        text-align: center;
        font-size: 5vw;
        color: #ffffff;
        border-radius: 10px;
        padding-top: 2.5%;
      }
    }

    .el-select-dropdown__item {
      font-size: 4vw;
      top: 1vw;
      height: 10vw;
      text-align: center;
      padding-top: 10%;
    }

    /deep/ .el-select-dropdown__wrap {
      max-height: 50vw !important; /* 设置您想要的最大高度 */
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/fxSetData.vue